
























import {namespace} from "vuex-class";
import {Vue, Component} from 'vue-property-decorator';
import InputTelephone from '@/views/components/Dropups/ReceiverPhone/InputTelephone.vue';
import {IPhoneNumber} from '@/models/IPhoneNumber.js';
const shipmentStore = namespace("shipment");


@Component({
  name: 'ReceiverPhone',
  components: {
    InputTelephone,
  },
})
export default class ReceiverPhone extends Vue {
  @shipmentStore.Getter("getToPhoneNumberSpaces")
  private getToPhoneNumberSpaces!: string;

  @shipmentStore.Getter("getToPhoneNumber")
  private getToPhoneNumber!: IPhoneNumber;

  private telephone: IPhoneNumber = {
    number: "",
    extension: "",
  };

  get isTelephoneCorrect(): boolean {
    return this.telephone.number !== "";
  }

  private created() {
    this.telephone = this.getToPhoneNumber;
  }

  private close() {
    if (this.isTelephoneCorrect) {
      // todo: check where this component is used and fix accordingly
      // this.$uiBus.emit("dropup:close");
      // this.$uiBus.emit("crossTownData:phone", this.telephone);
      this.$emit("receiverPhone:finish", this.telephone);
    }
  }
}
